export default __webpack_public_path__ + "static/media/logols2.8bd10b80.png";